import getContent from 'pp-react-l10n';
import React from 'react';
import { isExternalFlow } from '../utility/externalIntegrationUtils';
import * as FPT from '../utility/fpt';
import TemplateData from '../utility/getTemplateData';
import { isInContext, closeWindow } from '../utility/inContextDonation';

class CancelAndReturn extends React.Component {
  constructor() {
    super();
    this.state = {
      displayMe: TemplateData.charityCancelUrl ? true : false,
    };
  }

  handleCancel = () => {
    FPT.trackLinkClick('cancel');
    let cancelurl = TemplateData.charityCancelUrl;
    if (cancelurl.indexOf('http') != 0 && cancelurl.indexOf('//') != 0) {
      cancelurl = '//' + cancelurl;
    }
    window.location.href = cancelurl;
  };

  render() {
    const getCancelAndReturnContent = getContent('locals')(
      'common/cancelAndReturn'
    );

    if (isExternalFlow() || isInContext()) {
      return null;
    }

    return (
      <div>
        {this.state.displayMe && (
          <div
            className="ppvx_col-sm-12 text-center pp_cancel_btn_wrapper"
            data-testid="cancel-and-return-container"
          >
            <a
              href="#"
              className="ppvx_link pp_cancel_btn"
              id="cancelReturnBtn"
              onClick={this.handleCancel}
            >
              {getCancelAndReturnContent('label.return', {
                orgName: TemplateData.donationName,
              })}
            </a>
          </div>
        )}
      </div>
    );
  }
}

export default CancelAndReturn;
